<template>
  <div class="top_mobile">
    <div class="top_mobilea" v-show="caidan == 1">
      <div class="top_mobileleft">
        <img
            @click="jumpindex()"
            src="../../public/statics/img/mobile/logo.png"
            alt=""
        />
      </div>
      <div class="top_mobileright">
        <img
            src="../../public/statics/img/mobile/icon_dengl.png"
            alt=""
            @click="openloginbox"
            v-if="status == 0"
        />
        <div class="top_mobilerightinfo" v-if="status == 1">
          {{ name }}
          <span @click="logout">退出</span>
        </div>
        <img
            src="../../public/statics/img/mobile/icon_gengduo.png"
            alt=""
            @click="caidan = 2"
        />
      </div>
    </div>
    <div class="top_mobileb" v-show="caidan == 2" @touchmove.prevent>
      <div class="top_mobileb1">
        <div class="top_mobileb2">
          <img
              class="top_mobileb2img1"
              src="../../public/statics/img/mobile/logo.png"
              alt=""
          />
          <img
              class="top_mobileb2img2"
              src="../../public/statics/img/mobile/icon_guanbi.png"
              alt=""
              @click="caidan = 1"
          />
        </div>
        <div class="top_mobileb2r">
          <div class="top_mobileb2s" @click="jumppage(0)">
            <img
                src="../../public/statics/img/mobile/icon_shouye@2x.png"
                alt=""
            />
            <span>首页</span>
          </div>
          <div class="top_mobileb2s" @click="jumppage(1)">
            <img
                src="../../public/statics/img/mobile/icon_jiaru@2x.png"
                alt=""
            />
            <span>申请加入</span>
          </div>
          <div class="top_mobileb2s" @click="jumppage(2)">
            <img
                src="../../public/statics/img/mobile/icon_zhichi@2x.png"
                alt=""
            />
            <span>支持中心</span>
          </div>
          <div class="top_mobileb2s" @click="jumppage(3)">
            <img
                src="../../public/statics/img/mobile/icon_zixun@2x.png"
                alt=""
            />
            <span>资讯动态</span>
          </div>
          <div class="top_mobileb2s" @click="jumppage(4)">
            <img
                src="../../public/statics/img/mobile/icon_kefu@2x.png"
                alt=""
            />
            <span>客服中心</span>
          </div>
          <div class="top_mobileb2s" @click="jumppage(5)">
            <img
                src="../../public/statics/img/mobile/shop.png"
                alt=""
            />
            <span>生态云商城</span>
          </div>
          <div class="top_mobileb2s" @click="jumppage(7)">
            <img
                src="../../public/statics/img/loadimg.png"
                alt=""
            />
            <span>云货主App</span>
          </div>
          <div class="top_mobileb2s" @click="jumppage(8)">
            <img
                src="../../public/statics/img/loadimg.png"
                alt=""
            />
            <span>云车主App</span>
          </div>
        </div>
      </div>
    </div>
    <div class="top_mobilec" v-show="caidan == 3" @touchmove.prevent>
      <div class="top_mobilec1">
        <img
            src="../../public/statics/img/mobile/icon_guanbi@2x.png"
            alt=""
            @click="caidan = 1"
        />
        <img
            src="../../public/statics/img/mobile/icon_gengduo.png"
            alt=""
            @click="caidan = 2"
        />
      </div>
      <el-form ref="form" :model="form" style="width: 100%" :rules="rules">
        <div class="center">
          <div class="center_img">
            <p>登 录</p>
            <span>欢迎使用IDA云物流管理系统</span>
          </div>

          <!--切换登录-->
          <div class="center_change">
            <div class="center_changes" :class="[logintype==1?'center_changeactive':'']"
                 @click="changelogintype(1)">短信登录
            </div>
            <div class="center_changes" :class="[logintype==2?'center_changeactive':'']"
                 @click="changelogintype(2)">密码登录
            </div>
          </div>

          <div class="input_up">
            <div class="input_up_style">
              <p><span>*</span>账号:</p>
              <el-form-item prop="phone" style="height: 100%">
                <el-input v-model="form.phone" placeholder="请输入"></el-input>
              </el-form-item>
            </div>

            <div class="input_up_style" v-if="logintype==1">
              <p><span>*</span>验证码:</p>
              <el-form-item prop="code" style="height: 100%">
                <div style="display: flex; justify-content: space-between">
                  <el-input
                      type="code"
                      v-model="form.code"
                      style="width: 14rem"
                      placeholder="请输入"
                  ></el-input>
                  <el-button
                      v-show="shows == true"
                      type="primary"
                      style="width: 6rem; padding: 0 10px"
                      @click="getcode()"
                  >获取验证码
                  </el-button>
                  <el-button
                      v-show="shows == false"
                      type="primary"
                      style="width: 100px; padding: 0 10px"
                  >{{ count }}秒
                  </el-button>
                </div>
              </el-form-item>
            </div>
            <div class="input_up_style" v-if="logintype==2">
              <p><span>*</span>密码:</p>
              <el-form-item prop="password" style="height: 100%">
                <el-input type="password" v-model="form.password"
                          placeholder="请输入"></el-input>
              </el-form-item>
            </div>
            <!--新功能-->
            <div style="display: flex;justify-content: space-between;">
              <el-checkbox v-model="rememberme" @change="setremember" style="color: #FFFFFF;">记住我</el-checkbox>
              <span style="font-size: 14px;color: #ffffff;" @click="forgetVisble" v-if="logintype==2">忘记密码?</span>
            </div>

            <el-button type="primary" @click="submitForm" class="loginstyle"
            >登录
            </el-button>


          </div>
        </div>
      </el-form>
    </div>

    <!--      安全验证-->
    <el-dialog
        :visible.sync="isSafe"
        width="340px"
        custom-class="safeVerificatio"
        :append-to-body="true"
        :before-close="safeclost"
    >

      <div class="safeVerificatiobox">

        <img class="safe1" src="../../public/statics/img/safevila.png" alt="">
        <p class="safe2">安全验证</p>
        <p class="safe3">检测到您在新设备或异地登录，为了保护您的账户安全，需要进行身份验证</p>
        <div class="safe6">
          <div style="display: flex;margin-bottom: 6px; align-items: center;">
            <img src="../../public/statics/img/notice.png" style="width: 18px;height: 18px;margin-right: 10px;" alt="">
            检测到登录异常
          </div>
          <p style="margin-bottom: 10px;">登录地点: &nbsp;&nbsp; {{ safewarningInfo.address }} </p>
          <p>登录时间: &nbsp;&nbsp; {{ safewarningInfo.address_time }}</p>
        </div>
        <p class="safe4">短信验证码发送至手机 <span>{{ form.phone | reverse }}</span></p>
        <div class="safe5">
          <p> 短信验证码</p>
          <el-input v-model="safecode" placeholder="请输入验证码" style="width:120px;height: 32px;"></el-input>
          <el-button v-preventClick @click="getsafecode" type="primary" style="width:90px;padding:8px 10px;"
                     :disabled="safeshow">
            {{ safeshow ? safecout + '秒' : '发送验证码' }}
          </el-button>
        </div>
        <el-button v-preventClick type="primary" style="width: 300px;padding:8px 10px;margin-bottom: 10px;"
                   @click="safeandlogin">验证并登录
        </el-button>
        <el-button style="width: 300px;margin-left: 0;padding:8px 10px;" @click="safeclost(1)">取消登录</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const TIME_COUNT = 60;
import {auth, loginauth, anth} from "../request/api";
import Cookies from "js-cookie";
import {getToken, setToken, removeToken} from "../request/toekn";
import {mapGetters} from "vuex";
import {Toast} from "vant";
import {Dialog} from 'vant';

export default {
  name: "top_mobile",
  data() {
    return {
      caidan: 1,

      //登录表单
      form: {
        phone: "",
        password: "",
        code: "",
      },
      //登录验证
      rules: {
        phone: [
          {required: true, message: "请输入账号", trigger: "blur"},
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 8, message: '最少为8位', trigger: 'blur'}
        ],
        code: [{required: true, message: "请输入验证码", trigger: "blur"}],
      },

      //登录状态
      status: 0,
      count: "",
      shows: true,

      logintype: 1,
      rememberme: false,
      /*安全验证*/
      isSafe: false,//安全验证
      safetimer: null,
      safecout: 60,
      safeshow: false,
      safecode:'',
      FingerprintID: null,
      safewarningInfo:{
        address:'',
        address_time:'',
      }

    };
  },
  filters: {
    // 局部过滤器：反转字符串
    reverse: function (value) {
      let str1 = value.slice(0, 3)
      let str2 = value.slice(-4)
      return str1 + '****' + str2
    }
  },
  computed: {

    ...mapGetters(["name", "avatar", "companyname", "phone", "password"]),
  },
  created() {
    this.Fingerprint();

    this.rememberme = Lockr.get('isRemember') ? Lockr.get('isRemember') : false;
    if (Cookies.get(getToken()) && getToken()) {
      this.status = 1;
      this.getuserinfo();
    }
  },
  mounted() {
  },
  methods: {
    /*设备指纹*/
    async Fingerprint() {
      const result = await FingerprintJS.load();
      const visitorId = await result.get();
      // console.log(visitorId.visitorId); // 打印生成的指纹
      this.FingerprintID=visitorId.visitorId
    },
    //标签页
    jumppage(e) {
      setTimeout(() => {
        this.caidan = 1;
      }, 300);
      if (e == 0) {
        this.$router.push({path: "/index_mobile"});
      } else if (e == 1) {
        this.$router.push({path: "/edition_mobile"});
      } else if (e == 2) {
        this.$router.push({path: "/word_mobile"});
      } else if (e == 3) {
        this.$router.push({path: "/newviews_mobile"});
      } else if (e == 4) {
        this.$router.push({path: "/chat_mobile"});
      } else if (e == 5) {
        this.$router.push({path: "/shop_mobile"});
      } else if (e == 7) {
        this.$router.push({path: "/cargoOwner_mobile"});
      } else if (e == 8) {
        this.$router.push({path: "/carOwner_mobile"});
      }
    },
    getuserinfo() {
      this.$store
          .dispatch("GetInfo")
          .then((data) => {
            // console.log('成功')
          })
          .catch((data) => {
            if (data.data.code == 8000) {
              this.logout();
              this.loading = false;
            } else {
              console.log(1);
              this.$message.error(data);
              this.loading = false;
            }
          });
    },
    //登录表单提交
    submitForm(form) {

      // this.loading = true;
      this.$refs["form"].validate((valid) => {
        if (valid) {

          let APIstr = '';//
          let code = {
            phone: this.form.phone, //手机号
            FingerprintID:this.FingerprintID,
            user_agent:1,
            /*  type: 1,//2.3单点登录新增
            point_type:this.form.point_type,
            code: this.form.code, //验证码
            // password: this.form.password, //密码*/
          };

          //textlogin
          if (this.logintype == 1) {
            code.type = 1;
            code.point_type = this.form.point_type;
            code.code = this.form.code
            APIstr = 'Login'
          }
          //passlogin
          if (this.logintype == 2) {
            code.password = this.form.password
            APIstr = 'PassLogin'
          }
          Cookies.remove();
          removeToken();

          this.$store
              .dispatch(APIstr, code)
              .then((data) => {
                if (Cookies.get(getToken()) && getToken()) {
                  loginauth().then((res) => {
                    if (res.data.code == 1) {
                      let menus = res.data.data.menu;
                      if (menus != "") {
                        if (menus.user) {
                          Lockr.set("user", menus.user.children);
                        }
                        if (menus.transport) {
                          Lockr.set("transport", menus.transport.children);
                        }
                        if (menus.packing) {
                          Lockr.set("packing", menus.packing.children);
                        }
                      }
                      this.getuserinfo();
                      Toast.success("登录成功");
                      this.status = 1;
                      this.caidan = 1;
                      this.$router.push({path: "/index_mobile"});
                    } else {
                      Toast.fail(res.data.msg);
                      setTimeout(() => {
                        this.logout();
                      }, 500);
                      return;
                    }
                  });
                }
              })
              .catch((data) => {
                // this.$message.error(data);
                // Toast.fail(data);
                // this.loading = false;

                if (data.code == 8102) {
                  Dialog.alert({
                    title: '提示',
                    message: data.msg,
                  }).then(() => {
                    this.form.point_type = 2;
                    this.submitForm();
                  });
                }
                else if (data.code == 3)
                {
                  if (data.data.count_error == 0) {
                    let warningstr = '账号已锁定，请30分钟后重试或找回密码!';
                    Dialog.alert({
                      title: '提示',
                      message: warningstr,
                    }).then();

                  } else if (data.data.count_error >= 3) {
                    let warningstr = '您的账户由于多次尝试登录失败，即将被锁定。建议您： 通过【短信验证码】继续登录或通过【忘记密码】重置后再登录!';
                    Dialog.alert({
                      title: '提示',
                      message: warningstr,
                    }).then();
                  } else {
                    Toast('密码错误!')
                  }
                }
                else if (data.code == 99999 || data.code == 100000) {
                  this.isSafe = true;//触发安全验证
                  this.safewarningInfo.address=JSON.parse(JSON.stringify(data.data.address));
                  this.safewarningInfo.address_time=JSON.parse(JSON.stringify(data.data.address_time));
                }
                else {
                  Toast(data.msg)
                }
                this.loading = false


              });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 退出登录
    logout() {
      this.$store
          .dispatch("LogOut")
          .then((data) => {
            Toast.success("退出成功");
            this.caidan = 1;
            this.status = 0;
            this.$router.push({path: "/index_mobile"});
          })
          .catch((data) => {
            Toast.fail(data.data.msg);
          });
    },
    //获取验证码
    getcode() {
      if (this.form.phone == undefined || this.form.phone == "") {
        Toast.fail("请输入手机号");
      } else {
        let url = "/v1/member/login/send_sms";
        let data = {
          phone: this.form.phone,
          type: 1,
        };
        auth(url, data).then((res) => {
          if (res.data.code == 1) {
            this.count = TIME_COUNT;
            this.shows = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.shows = true;
                clearInterval(this.timer); // 清除定时器
                this.timer = null;
              }
            }, 1000);
          } else {
            Toast(res.data.msg);
          }
        });
      }
    },
    //
    jumpindex() {
      this.$router.push("/index_mobile");
    },

    //切换登录方式
    changelogintype(e) {
      if (e == this.logintype) {
        return
      }
      this.$refs['form'].resetFields();
      this.logintype = e;
      this.form.code = '';
      this.form.password = '';
    },
    //记住我
    setremember() {
      if (this.rememberme == true) {
        Lockr.set('isRemember', true)
      } else {
        Lockr.set('isRemember', false)
      }
    },
    forgetVisble() {
      Toast('请至PC端修改登录密码!')
    },
    openloginbox() {
      this.caidan = 3;
      this.$refs['form'].resetFields();
    },
    //安全验证-获取验证
    getsafecode() {
      if (this.form.phone == '') {
        Toast('请输入手机号!');
        return;
      }
      let url = '/v1/member/login/send_sms';
      let data = {
        phone: this.form.phone
      }
      auth(url, data).then(res => {
        if (res.data.code == 1) {
          this.safeshow = true;
          this.safetimer = setInterval(() => {
            this.safecout--;
            if (this.safecout == 0) {
              clearInterval(this.safetimer);
              this.safetimer = null;
              this.safecout = 60;
              this.safeshow = false;
            }
          }, 1000)
        } else {
          Toast(res.data.msg);
        }
      })
    },
    safeclost(e) {
      this.safetimer = null;
      this.safecout = 60;
      this.safeshow = false;
      this.isSafe = false;
      if(!e){
        //验证登录
        this.form.code=this.safecode;
        this.safecode='';
      }
    },
    //验证并登录
    safeandlogin() {
      this.safeclost();
      //验证登录
      this.logintype=1;
      setTimeout(() => {
        this.submitForm();
      }, 500)
    },
  },
};
</script>

<style scoped lang='scss'>
.top_mobile {
  .top_mobilea {
    z-index: 8;
    position: fixed;
    padding: 10px;
    height: 44px;

    width: 24rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .top_mobileleft {
      img {
        width: 60px;
      }
    }

    .top_mobileright {
      display: flex;
      align-items: center;

      .top_mobilerightinfo {
        color: #ffffff;
        font-family: "PingFang SC";
        font-size: 14px;
        margin-right: 1rem;
      }

      img {
        width: 16px;
        height: 16px;
      }

      img:first-child {
        width: 16px;
        height: 16px;
        margin-right: 0.5rem;
      }
    }
  }

  .top_mobileb {
    z-index: 8;
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;

    .top_mobileb1 {
      width: 100%;
      height: auto;
      padding-bottom: 2rem;

      .top_mobileb2 {
        width: 24rem;
        padding: 10px;
        height: 44px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        background: #202334;

        .top_mobileb2img1 {
          width: 60px;
          height: auto;
        }

        .top_mobileb2img2 {
          width: 16px;
          height: 16px;
        }
      }

      .top_mobileb2r {
        position: absolute;
        right: 0;
        width: 150px;
        box-sizing: border-box;
        background: #202334;

        .top_mobileb2s {
          width: 130px;
          height: auto;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border-bottom: 1px solid rgba(255, 255, 255, 0.5);
          margin: 10px;
          padding: 10px;
          box-sizing: border-box;

          img {
            width: 16px;
            margin-right: 10px;
          }

          img:first-child {
            width: 16px;
            height: 16px;
          }

          span {
            font-size: 14px;
          }

          color: #ffffff;
        }
      }
    }
  }

  .top_mobilec {
    z-index: 8;
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    /*background:#cccccc;*/
    box-sizing: border-box;
    background-image: url("../../public/statics/img/mobile/beijin.png");
    background-size: auto 100vh;

    .top_mobilec1 {
      padding: 10px;
      height: 44px;
      box-sizing: border-box;
      width: 24rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
      }
    }

    .center {
      width: 100%;
      height: auto;
      padding: 0 20px 0 20px;
      box-sizing: border-box;
      margin-top: 6px;

      .center_img {
        width: 100%;
        height: 39px;
        display: flex;
        /*margin-bottom: 11px;*/
        justify-content: center;
        margin: 30px 0 10px;
        flex-direction: column;
        align-items: center;

        p {
          width: auto;
          height: 50px;
          font-size: 30px;
          font-family: "PingFang SC";
          /*font-weight: bold;*/
          line-height: 41px;
          color: #ffffff;
          letter-spacing: 5px;
        }

        span {
          margin: 10px 0;
          color: #FFFFFF;
        }
      }

      /*切换登录*/
      .center_change {
        margin-top: 24px;
        padding: 8px 10px;
        box-sizing: border-box;
        //background: #F7F7FA;
        display: flex;
        justify-content: space-around;
        margin-bottom: 10px;

        .center_changes {
          width: 160px;
          height: 38px;
          text-align: center;
          line-height: 38px;
          font-size: 16px;
          color: #333333;
          cursor: pointer;
          background: #F7F7FA;
          border-radius: 10px;
        }

        .center_changeactive {
          width: 160px;
          height: 38px;
          background: #FFFFFF;
          color: #409EFF;
          font-weight: bold;
        }
      }

      .input_up {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .input_up_style {
          height: 94px;
          display: flex;
          flex-direction: column;

          p {
            font-size: 14px;
            font-family: "PingFang SC";
            line-height: 24px;
            color: #fff;
            text-align: left;

            span {
              color: #f35959;
              margin-right: 5px;
            }
          }
        }

        .input_up_style1 {
          height: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          div {
            display: flex;

            i {
              font-size: 16px;
              color: #fba962;
              line-height: 20px;
            }

            p {
              font-size: 14px;
              font-family: "PingFang SC";
              color: #606266;
              line-height: 20px;
            }
          }

          span {
            font-size: 14px;
            line-height: 20px;
            font-family: "PingFang SC";
            color: #3d68eb;
            cursor: pointer;
          }
        }

        .loginstyle {
          width: 100%;
          height: 42px;
          padding: 0 10px;
          font-size: 16px;
          cursor: pointer;
          margin-top: 20px;
        }
      }

      .center_bottom {
        width: 100%;
        height: 16px;
        margin-top: 50px;
        display: flex;
        justify-content: space-between;

        .jump-icon {
          background: #666;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 14px;
          height: 14px;
          font-size: 10px;
          color: #fff;
          margin-right: 5px;
        }

        .jump-bar {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #595959;
          padding-right: 10px;
          cursor: pointer;
        }

        .jump-bar:hover {
          color: #66b1e1;
        }
      }
    }
  }

}
</style>
<style lang="scss">
.safeVerificatio {
  /*安全验证*/
  .safeVerificatiobox {
    display: flex;
    flex-direction: column;
    align-items: center;

    .safe1 {
      width: 40px;
      height: 40px;
      margin-bottom: 10px;
    }

    .safe2 {
      font-size: 24px;
      color: #333333;
      margin: 6px 0;
      font-weight: bold;
    }

    .safe3 {
      font-size: 12px;
      color: #999999;
      line-height: 20px;
      margin-bottom: 10px;
    }

    .safe4 {
      width: 300px;
      font-size: 12px;
      color: #999999;
      margin-bottom: 10px;
    }

    .safe5 {
      width: 300px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      p {
        font-size: 14px;
        color: #2B2C44;
      }

    }

    .safe6 {
      width: 300px;
      padding: 16px;
      box-sizing: border-box;
      font-size: 12px;
      color: #FF7929;
      background: rgba(255, 121, 41, .16);
      border-radius: 4px;
      margin-bottom: 10px;
    }

  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body{
    padding:20px;
  }
  .el-input__inner {
    height: 32px !important;
  }
}
</style>
